import { FunctionComponent, useEffect, useState } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import { Input, Button, Form, Alert } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { localLogin, isLocallyAuthenticated, localLogout, useLocalAuth } from '../../auth/LocalAuthService';
import { resetToken } from '../../auth/UserService';
import logo from '../../assets/images/logo.png';

const LoginPage: FunctionComponent = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const history = useHistory();
    const localAuth = useLocalAuth();

    useEffect(() => {
        // Clear only auth session keys to avoid stale role/session bleed on fresh login.
        localLogout();
        resetToken();
    }, []);

    if (localAuth && isLocallyAuthenticated()) {
        return <Redirect to="/documents" />;
    }

    const onFinish = async (values: { username: string; password: string }) => {
        setLoading(true);
        setError('');
        try {
            await localLogin(values.username, values.password);
            history.push('/documents');
        } catch (err: any) {
            const msg = err?.response?.data?.message || 'Login failed. Check your credentials.';
            setError(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxSizing: 'border-box',
                paddingTop: 24,
                paddingBottom: 24,
                background: 'linear-gradient(135deg, #0A1E36 0%, #12304D 100%)',
            }}
        >
            <div
                style={{
                    width: 400,
                    padding: '40px 32px',
                    borderRadius: 12,
                    background: '#fff',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
                }}
            >
                <div style={{ textAlign: 'center', marginBottom: 24 }}>
                    <img src={logo} alt="Ascend-Invest" style={{ width: 150, height: 'auto' }} />
                </div>
                <p style={{ textAlign: 'center', marginBottom: 28, color: '#8c8c8c', fontSize: 14 }}>
                    Sign in to your account
                </p>

                {error && (
                    <Alert
                        message={error}
                        type="error"
                        showIcon
                        style={{ marginBottom: 20 }}
                        closable
                        onClose={() => setError('')}
                    />
                )}

                <Form onFinish={onFinish} size="large">
                    <Form.Item name="username" rules={[{ required: true, message: 'Enter username or email' }]}>
                        <Input prefix={<UserOutlined />} placeholder="Username or email" autoFocus />
                    </Form.Item>
                    <Form.Item name="password" rules={[{ required: true, message: 'Enter password' }]}>
                        <Input.Password prefix={<LockOutlined />} placeholder="Password" />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            block
                            style={{
                                height: 44,
                                borderRadius: 8,
                                fontWeight: 500,
                                background: '#1A60A6',
                                borderColor: '#1A60A6',
                            }}
                        >
                            Sign In
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default LoginPage;
